import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './icon.js';

const draggableListItemCss = ".wui-draggable-list-item{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;background-color:hsla(0,0%,100%,.001);border-bottom:1px solid var(--jw-theme-surface-border-border-color);box-sizing:border-box;color:var(--jw-theme-surface-text-default-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:1rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:1rem;transition:background-color .1s ease-in-out;width:100%}.wui-draggable-list-item *,.wui-draggable-list-item :after,.wui-draggable-list-item :before{box-sizing:inherit}.wui-draggable-list-item img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.wui-draggable-list-item__content{height:100%;width:100%}.wui-draggable-list-item__drag{border-radius:50%;cursor:grab;height:1rem;width:1rem}.wui-draggable-list-item__drag wui-icon{color:var(--jw-theme-surface-text-description-color);height:1rem;width:1rem}.wui-draggable-list-item__drag:active{cursor:grabbing}.wui-draggable-list-item.-dropzone{background:var(--jw-theme-surface-item-hover-bg-color)}.wui-draggable-list-item.-chosen{background-color:var(--jw-theme-surface-item-active-alt-bg-color)}.wui-draggable-list-item:hover{background-color:var(--jw-theme-surface-item-hover-bg-color)}.wui-draggable-list-item:only-child{border:none}.wui-draggable-list-item:only-child .wui-draggable-list-item__drag{display:none}";
const WuiDraggableListItemStyle0 = draggableListItemCss;

const WuiDraggableListItem$1 = /*@__PURE__*/ proxyCustomElement(class WuiDraggableListItem extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.uid = undefined;
    }
    render() {
        return (h(Host, { key: 'ae364183db47678d4b1833488d2f20d79eb84cde', class: "wui-draggable-list-item" }, h("div", { key: 'c50b12e8c22137ffccbbd7cdcc126fd06a14c3fa', class: "wui-draggable-list-item__drag" }, h("wui-icon", { key: '45fe7e637fbc20ac6f5946393ec920b90f1af443', name: "grip-vertical" })), h("div", { key: 'fd1e01cda6e2eb1f63e10f31f989e70a198883d2', class: "wui-draggable-list-item__content" }, h("slot", { key: '01a0f80b01b232cfd798d1d09cc86bf937ee7e47' }))));
    }
    static get style() { return WuiDraggableListItemStyle0; }
}, [4, "wui-draggable-list-item", {
        "uid": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-draggable-list-item", "wui-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-draggable-list-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDraggableListItem$1);
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiDraggableListItem = WuiDraggableListItem$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDraggableListItem, defineCustomElement };

//# sourceMappingURL=wui-draggable-list-item.js.map